<template>
  <div class="page-wrapper">
    <div class="page-content">
      <history-tickets :h5carUrl="this.h5carUrl"></history-tickets>
    </div>
  </div>
</template>

<script>
import historyTickets from './historyTickets.vue'

export default {
  name: 'HistoryTicketsIndex',
  components: {
    historyTickets,
  },
  data() {
    return {
      h5carUrl: '',
      designRem: 37.5,
    }
  },
  created() {
    const url = window.location.href
    this.h5carUrl = url || ''
  },
   mounted() {
    // 等待flexible.js完成rem计算后，再进行我们的放大处理
    this.waitForFlexibleAndAdjust()
    
    // 监听窗口变化
    window.addEventListener('resize', this.handleResize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    waitForFlexibleAndAdjust() {
      setTimeout(() => {
        this.adjustRemBasedOnFlexible()
      }, 100)
    },
    
    handleResize() {
      this.waitForFlexibleAndAdjust()
    },
    
    adjustRemBasedOnFlexible() {
      const docEl = document.documentElement
      const lib = window['lib'] || {}
      const flexible = lib.flexible || {}
      
      const currentRem = parseFloat(docEl.style.fontSize) || flexible.rem || 25.6
      
      const scale = this.designRem / currentRem
      
      const newRem = currentRem * scale
      
      docEl.style.fontSize = newRem + 'px'
      
      if (flexible) {
        flexible.rem = window.rem = newRem
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-wrapper {
  width: 100%;
  box-sizing: border-box;
}

.page-content {
  width: 100%;
  box-sizing: border-box;
}
</style>

<style lang="less">

::-webkit-scrollbar {
  width: 0;
  height: 0;
  background: transparent;
}
@media screen and (max-width: 768px) {
  .el-message {
    min-width: auto;
  }
}
</style>